import { useQuery } from '@tanstack/react-query';
import { getAuthMe } from 'src/services/apis/services';
import { QUERIES } from 'src/utils/react-query';

export function useAuthUser() {
  const authUserQuery = useQuery([QUERIES.AUTH_USER], getAuthMe);
  return authUserQuery.data;
}
